import React from "react"
import { MainCP } from "../../../Components/instituciones/instituciones-v2/MainCP"

const ViewInstituciones: React.FC = () => <MainCP/>

export default ViewInstituciones